import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';

import { AuthProvider } from '@/features/auth/AuthProvider';
import i18n from '@/i18n';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';

import { queryClient } from './queryClient';

/**
 * Provider order matters: the boundary is outermost so it catches failures in
 * everything below it, and Auth sits inside Query because session restore is
 * itself an HTTP call.
 *
 * Anything needing an authenticated client — kdoshr-app's notification socket,
 * for instance — goes inside AuthProvider, not beside it.
 */
export function Providers({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>{children}</AuthProvider>
        </QueryClientProvider>
      </I18nextProvider>
    </ErrorBoundary>
  );
}
